const ChangeChannelStatistics = () =>
  import('@/views/main/externalStatistics/changeChannelStatistics/ChangeChannelStatistics.vue')
export default {
  path: '/main/externalStatistics/changeChannelStatistics',
  name: 'ChangeChannelStatistics',
  component: ChangeChannelStatistics,
  children: []
}
